import { render, staticRenderFns } from "./AverageCallDuration.vue?vue&type=template&id=560658ed&scoped=true"
import script from "./AverageCallDuration.vue?vue&type=script&lang=js"
export * from "./AverageCallDuration.vue?vue&type=script&lang=js"
import style0 from "./AverageCallDuration.vue?vue&type=style&index=0&id=560658ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560658ed",
  null
  
)

export default component.exports